<script setup lang="ts">
const route = useRoute()
const authStore = useUserAuthStore()

const isBarePage = computed(() => route.path.includes('/print') || route.path === '/')
const isOpenSidebarMobile = ref(false)

watch(() => route.fullPath, () => {
  isOpenSidebarMobile.value = false
})
</script>

<template>
  <div v-if="!isBarePage && !!authStore.role" class="app-shell">
    <AppSideBar
      :username="authStore?.username || ''"
      :is-open="isOpenSidebarMobile"
      @close="isOpenSidebarMobile = false"
    />
    <div
      v-if="isOpenSidebarMobile"
      class="sidebar-backdrop"
      @click="isOpenSidebarMobile = false"
    />
    <main class="app-main has-sidebar">
      <div class="mobile-topbar">
        <button class="mobile-topbar-toggle" type="button" @click="isOpenSidebarMobile = true">
          <Icon name="mdi:menu" size="22px" />
        </button>
        <span class="mobile-topbar-title">Cipondo Powerindo</span>
      </div>
      <NuxtPage />
    </main>
  </div>
  <NuxtPage v-else class="section" />
</template>

<style>
html {
  font-family: "Open Sans", sans-serif;
}
</style>
